module.exports = __webpack_public_path__ + "img/reply_tool_emoji.deb59124.svg";